// extracted by mini-css-extract-plugin
export default {"category":"Category_category__3GwaE","catgory__item":"Category_catgory__item__73mfr"};